import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 45 45",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 9.6,
			y: 42.5,
			className: "icon-fill-primary",
			width: 26.3,
			height: 2.5
		}),
		/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("polygon", {
			className: "icon-fill-primary",
			points: "45 41.4 39.9 41.4 39.9 38.9 42.5 38.9 42.5 17.1 39.9 17.1 39.9 14.6 45 14.6"
		}), /* @__PURE__ */ _jsx("polygon", {
			className: "icon-fill-primary",
			points: "5.2 41.4 .1 41.4 .1 14.6 5.2 14.6 5.2 17.1 2.6 17.1 2.6 38.9 5.2 38.9"
		})] }),
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("rect", {
				x: 30.8,
				y: 11,
				className: "icon-fill-primary",
				width: 4.8,
				height: 2.5
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 9.4,
				y: 11,
				className: "icon-fill-primary",
				width: 4.9,
				height: 2.5
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-fill-primary",
				d: "M22.5 20.8c-1.3 0-2.6-.5-3.6-1.5L13 13.5V3.9h19v9.5l-5.9 5.8c-1 1.1-2.3 1.6-3.6 1.6zm-7-8.4l5.2 5.1c1 1 2.7 1 3.8 0l5.2-5.1v-6H15.5v6z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-fill-primary",
				d: "M34.9 6.4H10.1V0h24.7v6.4zM12.6 3.9h19.7V2.5H12.6v1.4z"
			})
		] }),
		/* @__PURE__ */ _jsx("rect", {
			x: 36.6,
			y: 11,
			className: "icon-fill-secondary",
			width: 2.5,
			height: 5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 36.6,
			y: 18.3,
			className: "icon-fill-secondary",
			width: 2.5,
			height: 5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 36.6,
			y: 25.5,
			className: "icon-fill-secondary",
			width: 2.5,
			height: 5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 36.6,
			y: 32.8,
			className: "icon-fill-secondary",
			width: 2.5,
			height: 5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 36.6,
			y: 40,
			className: "icon-fill-secondary",
			width: 2.5,
			height: 5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 6,
			y: 11,
			className: "icon-fill-secondary",
			width: 2.5,
			height: 5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 6,
			y: 18.3,
			className: "icon-fill-secondary",
			width: 2.5,
			height: 5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 6,
			y: 25.5,
			className: "icon-fill-secondary",
			width: 2.5,
			height: 5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 6,
			y: 32.8,
			className: "icon-fill-secondary",
			width: 2.5,
			height: 5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 6,
			y: 40,
			className: "icon-fill-secondary",
			width: 2.5,
			height: 5
		})
	]
});
export default SvgIcon;
